import {prefixShopPublicPath} from '~/utils/shopHost'
import {shopPaths} from '~/utils/shopStorefront'

/** Адреса витрины с локальным префиксом `/katalog`. На поддомене префикс пустой. */
export function useShopPaths(): typeof shopPaths {
    const {shopPathPrefix} = useShopHost()

    return new Proxy(shopPaths, {
        get(target, prop, receiver) {
            const value = Reflect.get(target, prop, receiver)

            if (typeof value !== 'function') {
                return value
            }

            return (...args: unknown[]) => prefixShopPublicPath(
                (value as (...params: unknown[]) => string)(...args),
                shopPathPrefix.value,
            )
        },
    })
}
